import r from "../managers/braze-instance.js";
import { logger as N, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import ee, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function enableSDK() {
  new ee.se(null, !0).remove(s.me);
  const e = et.Ds.Us;
  new et(e, N).ge(e.Ls.pe, e.be),
    N.info("enableSDK was called"),
    r.destroy(!1),
    r.fe(!1);
}
